/* eslint-disable react/jsx-no-target-blank */

import Link from 'next/link';
import React from 'react';

type Props = {
  className?: string;
  to: string;
  newTab?: boolean;
  children?: React.ReactNode;
};

const PageLink = (props: Props) => {
  if (props.to.startsWith('http')) {
    return (
      <a
        className={'page-link ' + props.className}
        href={props.to}
        target={props.newTab ? '_blank' : '_self'}
        rel={props.newTab ? 'noopener noreferrer' : ''}
      >
        {props.children}
      </a>
    );
  }

  return (
    <Link href={props.to}>
      <a className={'page-link ' + props.className}>{props.children}</a>
    </Link>
  );
};

PageLink.defaultProps = { newTab: false };

export default PageLink;
